import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { NbActionsModule, NbBadgeModule, NbCardModule, NbCheckboxModule, NbContextMenuModule, NbSpinnerModule, NbToggleModule } from "@nebular/theme";
import { ChartsModule } from 'ng2-charts';

import {
  NbAutocompleteModule,
  NbIconModule,
  NbInputModule,
  NbLayoutModule,
  NbToastrModule,
  NbSelectModule,
  NbFormFieldModule,
  NbButtonModule,
  NbDatepickerModule,
  NbTooltipModule
} from "@nebular/theme";

import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';

import { UserCardComponent } from "./user-card/user-card.component";
import { UserCardSlimComponent } from "./user-card-slim/user-card-slim.component";
import { VehiclesCardSlimComponent } from "./vehicles-card-slim/vehicles-card-slim.component";
import { UserFilterComponent } from "./user-filter/user-filter.component";
import { SpinnerComponent } from "./spinner/spinner.component";
import { PopupImageComponent } from "./popup-image/popup-image.component";
import { TagAcessPointComponent } from "./tag-acess-point/tag-acess-point.component";
import { NbTagModule } from "@nebular/theme";
import { NbEvaIconsModule } from "@nebular/eva-icons";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AuthCompareComponent } from "./auth-compare/auth-compare.component";
import { ReportUserCardComponent } from "./report-user-card/report-user-card.component";
import { DeliveryPackageCardSlimComponent } from "./delivery-package-card-slim/delivery-package-card-slim.component";
import { FilterPeriodComponent } from './filter-period/filter-period.component';
import { FilterVehicleComponent } from './filter-vehicle/filter-vehicle.component';
import { FilterUnitComponent } from './filter-unit/filter-unit.component';
import { TagAuthTypesComponent } from './tag-auth-types/tag-auth-types.component';
import { InviteCardComponent } from "./invite-card/invite-card.component";
import { InvitationCardComponent } from './invitation-card/invitation-card.component';
import { AuthorizationCountersChartComponent } from './authorization-counters-chart/authorization-counters-chart.component';
import { AccessCounterChartComponent } from './access-counter-chart/access-counter-chart.component';
import { StatusCounterChartComponent } from './status-counter-chart/status-counter-chart.component';
import { AuthTypeCounterChartComponent } from './auth-type-counter-chart/auth-type-counter-chart.component';
import { VehicleSpeedChartComponent } from './vehicle-speed-chart/vehicle-speed-chart.component';
import { TranslateModule } from "@ngx-translate/core";
import { ThemeModule } from "../@theme/theme.module";
import { NbDateFnsDateModule } from "@nebular/date-fns";
import { NgxMaskModule } from "ngx-mask";
import { DeliverOrderComponent } from './deliver-order/deliver-order.component';
import { FilterServiceProviderCompanyComponent } from './filter-service-provider-company/filter-service-provider-company.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { PhotoB64EventComponent } from './photoB64-event/photoB64-event.component';
import { ButtonAnonymizeComponent } from './button-anonymize/button-anonymize.component';
import { BtnDownloadsReportComponent } from './btn-downloads-report/btn-downloads-report.component';
import { EditBlockadeComponent } from "./edit-blockade/edit-blockade.component";
import { ProceedAlertComponent } from "./proceed-alert/proceed-alert.component";
import { TagsRoleSubTypesComponent } from './tags-role-sub-types/tags-role-sub-types.component';
import { AuthorizationsFilterButtonsComponent } from './authorizations-filter-buttons/authorizations-filter-buttons.component';

@NgModule({
  imports: [
    NbCardModule,
    CommonModule,
    NbSpinnerModule,
    NbTagModule,
    NbAutocompleteModule,
    NbIconModule,
    NbInputModule,
    NbLayoutModule,
    NbToastrModule,
    NbSelectModule,
    NbEvaIconsModule,
    NbFormFieldModule,
    FormsModule,
    NbButtonModule,
    NgxMaterialTimepickerModule,
    NbDatepickerModule,
    NbTooltipModule,
    NbCheckboxModule,
    ChartsModule,
    NbContextMenuModule,
    NbBadgeModule,
    NbActionsModule,
    TranslateModule,
    ThemeModule,
    ReactiveFormsModule,
    NbDateFnsDateModule,
    NgxMaskModule,
    NbToggleModule,
  ],
  declarations: [
    UserCardComponent,
    InviteCardComponent,
    InvitationCardComponent,
    UserCardSlimComponent,
    VehiclesCardSlimComponent,
    UserFilterComponent,
    SpinnerComponent,
    PopupImageComponent,
    TagAcessPointComponent,
    AuthCompareComponent,
    ReportUserCardComponent,
    DeliveryPackageCardSlimComponent,
    FilterPeriodComponent,
    FilterVehicleComponent,
    FilterUnitComponent,
    TagAuthTypesComponent,
    AuthorizationCountersChartComponent,
    AccessCounterChartComponent,
    StatusCounterChartComponent,
    AuthTypeCounterChartComponent,
    VehicleSpeedChartComponent,
    DeliverOrderComponent,
    FilterServiceProviderCompanyComponent,
    ChangePasswordComponent,
    EditBlockadeComponent,
    ProceedAlertComponent,
    PhotoB64EventComponent,
    ButtonAnonymizeComponent,
    BtnDownloadsReportComponent,
    TagsRoleSubTypesComponent,
    AuthorizationsFilterButtonsComponent
  ],
  exports: [
    UserCardComponent,
    InviteCardComponent,
    InvitationCardComponent,
    UserCardSlimComponent,
    VehiclesCardSlimComponent,
    UserFilterComponent,
    FilterPeriodComponent,
    FilterVehicleComponent,
    FilterUnitComponent,
    TagAuthTypesComponent,
    SpinnerComponent,
    NbSpinnerModule,
    PopupImageComponent,
    TagAcessPointComponent,
    ReportUserCardComponent,
    DeliveryPackageCardSlimComponent,
    AuthorizationCountersChartComponent,
    AccessCounterChartComponent,
    StatusCounterChartComponent,
    AuthTypeCounterChartComponent,
    VehicleSpeedChartComponent,
    DeliverOrderComponent,
    FilterServiceProviderCompanyComponent,
    ChangePasswordComponent,
    EditBlockadeComponent,
    PhotoB64EventComponent,
    NbTagModule,
    NbAutocompleteModule,
    NbIconModule,
    NbInputModule,
    NbLayoutModule,
    NbToastrModule,
    NbSelectModule,
    NbEvaIconsModule,
    NbFormFieldModule,
    ChartsModule,
    ButtonAnonymizeComponent,
    BtnDownloadsReportComponent,
    TagsRoleSubTypesComponent,
    AuthorizationsFilterButtonsComponent
  ],
  providers: [PopupImageComponent],
})
export class ComponentsModule {}
